import styled from 'styled-components'

export const EmblaViewport = styled.div`
  overflow: hidden;
  height: 100%;
`

export const EmblaContainer = styled.div`
  display: flex;
  height: 100%;
`

export const EmblaSlide = styled.div`
  position: relative;
  flex: 0 0 100%;
  min-width: 0;
  height: 100%;
`
